import { Spin, Tabs } from "antd";
import { TabsProps } from "antd/lib";
import { FileSliders, Settings, Signpost, UserSearch } from "lucide-react";
import { useEffect, useState } from "react";
import {
  CommonExamQuestionsTab,
  ExamPeriodPrimarySettings,
  ExamPeriodPublish,
  ExamPeriodUsers,
} from "@components";
import { useTranslation } from "react-i18next";
import { Exam, ExamPeriod } from "@types";
import { useParams } from "react-router-dom";
import { useGetExamPeriodById } from "@hooks";
import { useExamStore } from "@store";
// import { useExamStore } from "@store";


export const NewExamPeriodPage = () => {
  const [activeKey, setActiveKey] = useState("1");
  const { t } = useTranslation();
  const [selectedExam, setSelectedExam] = useState<Exam | undefined>(undefined);
  const [selectedExamPeriod, setSelectedExamPeriod] = useState<ExamPeriod | undefined>(undefined);
  const { id, examId } = useParams();
  const {data, isLoading} = useGetExamPeriodById(id || selectedExamPeriod?.id);
  const currentUser = useExamStore((state) => state.currentUser);

  const handleTabClick = (key: string) => {
    setActiveKey(key);
  };

  useEffect(() => {
    if (data) {
      setSelectedExamPeriod(data);
    }
  }, [data]);

  const isTermAdminOnly =
    currentUser?.applicationRoles.some((role) => role.name === "TermAdmin") &&
    !currentUser?.applicationRoles.some((role) => role.name === "ExamAdmin");

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("pages.examPeriods.primarySettingsTab.name"),
      children: (
        <ExamPeriodPrimarySettings
          examPeriod={selectedExamPeriod}
          setSelectedExam={setSelectedExam}
          setSelectedExamPeriod={setSelectedExamPeriod}
          setActiveKey={setActiveKey}
          selectedExam={selectedExam}
          examId={examId}
          key={"exam-period-primary"}
        />
      ),
      icon: <Settings />,
    },
    ...(!isTermAdminOnly ? [{
      key: "2",
      disabled: !(currentUser?.applicationRoles.some((role) => role.name === "ExamAdmin") && selectedExamPeriod),
      label: t("pages.examPeriods.confTab.name"),
      children: (
        <CommonExamQuestionsTab
          examPeriodScreen={true}
          setActiveKey={setActiveKey}
          examPeriod={selectedExamPeriod!}
          exam={selectedExam!}
          key={"exam-period-conf"}
        />
      ),
      icon: <FileSliders />,
    }] : []),
    {
      key: "3",
      disabled: !selectedExamPeriod,
      label: t("pages.examPeriods.applicantsTab.name"),
      children: (
        <ExamPeriodUsers
          setActiveKey={setActiveKey}
          examPeriod={selectedExamPeriod!}
          key={"exam-period-users"}
        />
      ),
      icon: <UserSearch />,
    },
    {
      key: "4",
      disabled: !selectedExamPeriod,
      label: t("pages.examPeriods.publishTab.name"),
      children: (
        <ExamPeriodPublish
          examPeriod={selectedExamPeriod!}
          key={"exam-period-publish"}
        />
      ),
      icon: <Signpost />,
    },
  ];

  return (
    <Spin spinning={isLoading}>
    <Tabs
      animated
      onTabClick={handleTabClick}
      defaultActiveKey={activeKey}
      activeKey={activeKey}
      items={items}
    />
    </Spin>
  );
};
